import { Component, input, inject, signal, computed, viewChild, ElementRef } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { BaseNotesService, type Note } from "@classes/notes.class";
import type { IAction } from "@shared/interfaces";
import { ActionTypeEnum } from "@shared/interfaces";
import { ModalComponent } from "@components/index";
import { WkTranslatePipe } from "@shared/index";
import { WkIconNoRecordsSpritePds3 } from "@icons/index";

@Component({
    selector: "wk-notes-panel",
    imports: [TranslateModule, JumpstartComponentsModule, ModalComponent, WkTranslatePipe, WkIconNoRecordsSpritePds3],
    templateUrl: "./notes-panel.component.html",
    styleUrl: "./notes-panel.component.scss",
})
export class NotesPanelComponent<S extends Note> {
    protected readonly notesService = inject(BaseNotesService) as unknown as BaseNotesService<S>;

    public id = input.required<string | undefined>();
    public placeholder = input.required<string>();

    protected addModal = signal<boolean>(false);
    protected noteToDelete = signal<S | null>(null);

    protected confirmAddAction = computed<IAction>(() => {
        return { event: this.addNote.bind(this), title: "iFirmTaxNotes.AddANote", type: ActionTypeEnum.Info };
    });

    protected confirmDeleteAction = computed<IAction>(() => {
        return { event: this.deleteNote.bind(this), title: "iFirmTaxNotes.DeleteNoteTitle", type: ActionTypeEnum.Danger };
    });

    private addNoteField = viewChild<ElementRef<HTMLTextAreaElement>>("addNote");

    private addNote(): void {
        const note = this.addNoteField()?.nativeElement?.value.trim();
        this.addModal.set(false);
        if (!note) return;
        const id = this.id();
        if (!id) return;
        this.notesService.add(id, note);
    }

    private deleteNote(): void {
        const noteId = this.noteToDelete()?.id.toString();
        this.noteToDelete.set(null);
        if (!noteId) return;
        const id = this.id();
        if (!id) return;
        this.notesService.delete(id, noteId);
    }
}
